import { ApiClient } from '@/lib/apiClient';
import type { CreateInboundSustainabilityData, InboundSustainabilityData } from '@/types/inboundSustainabilityData';

export default class InboundSustainabilityDataService extends ApiClient<InboundSustainabilityData, CreateInboundSustainabilityData> {

  constructor() {
    super('/v1/inboundsustainabilitydata', 'id');
  }
}
